import { useEffect, useState } from "react";
import { UnitService } from "@propertelligent/client-api";
import apiHelper from "../../utils/apiHelper";

export const useUnitData = (unitId: number) => {
  const [unitData, setUnitData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUnitData = async () => {
      try {
        const res: any = await apiHelper(
          UnitService.getApiUnit1,
          { showNotification: false },
          unitId
        );
        setUnitData(res?.data?.success || {});
      } catch (err) {
        console.error("Error fetching unit data:", err);
      } finally {
        setLoading(false);
      }
    };
    if (unitId) fetchUnitData();
  }, [unitId]);

  return { unitData, loading };
};
